import { createAsyncThunk } from '@reduxjs/toolkit'
import ApprovedMedia from './approved-media-model'
import {
  delete_approvedMedia,
  load_approvedMedias,
  store_approvedMedia,
} from './approvedMedia-service'

export const LoadApprovedMediasAsync = createAsyncThunk<any, any>(
  'composer/load/approvedMedia',
  async (params: { uid: string }) => {
    return await load_approvedMedias(params)
  },
)

export const CreateApprovedMediaAsync = createAsyncThunk<any, any>(
  'composer/create/approvedMedia',
  async (params: ApprovedMedia) => {
    return await store_approvedMedia(params)
  },
)

export const DeleteApprovedMediaAsync = createAsyncThunk<any, any>(
  'composer/delete/approvedMedia',
  async (params) => {
    return await delete_approvedMedia(params)
  },
)
